import type { Resource, ResourceKey, i18n as I18nInstance } from 'i18next'

export const getRegisteredNamespaces = <Namespace extends string = string>(
  namespaces: unknown,
): Namespace[] => {
  if (typeof namespaces === 'string') return [namespaces as Namespace]
  if (Array.isArray(namespaces)) {
    return namespaces.filter((namespace): namespace is Namespace => typeof namespace === 'string')
  }

  return []
}

export const registerNamespaces = (i18n: I18nInstance, namespaces: string[]) => {
  i18n.options.ns = Array.from(
    new Set([...getRegisteredNamespaces(i18n.options.ns), ...namespaces]),
  )
}

export const addI18nResourceBundle = (
  i18n: I18nInstance,
  language: string,
  namespace: string,
  resourceBundle: ResourceKey,
) => {
  if (i18n.hasResourceBundle(language, namespace)) return

  i18n.addResourceBundle(language, namespace, resourceBundle, true, true)
}

export const addI18nResources = (i18n: I18nInstance, resources: Resource) => {
  Object.entries(resources).forEach(([language, languageResources]) => {
    Object.entries(languageResources ?? {}).forEach(([namespace, resourceBundle]) => {
      addI18nResourceBundle(i18n, language, namespace, resourceBundle)
    })
  })
}
